import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/theme.css'
import { affiliateLink } from '@/utils/affiliateFlag'
import { handleRouteChunkError, NOTE_EVENT } from '@/utils/chunkReload'

const app = createApp(App)
app.use(router)
// CP-274: a lazy route's chunk is gone (tab opened before a deploy). Reload once, straight to the target URL, so the
// no-store index.html brings the new bundle; a second failure within 60s shows the note in the main area instead.
router.onError((err, to) => {
  let storage = null
  try { storage = window.sessionStorage } catch (_) { /* blocked storage: no auto reload (guard reads it as used) */ }
  const result = handleRouteChunkError(err, to, {
    storage,
    now: Date.now(),
    assign: (url) => window.location.assign(router.resolve(url).href),
    showNote: (url) => window.dispatchEvent(new CustomEvent(NOTE_EVENT, { detail: { url: router.resolve(url).href } }))
  })
  if (result === 'ignore') console.error(err) // what vue-router logs for an unhandled navigation error
})
// CP-212: counts rendered affiliate links for the footer commission line.
app.directive('affiliate-link', affiliateLink)
app.mount('#app')
